/**
 * Turnstile configuration
 */

export const TURNSTILE_CONFIG = {
  SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  SESSION_TTL_MS: Number(import.meta.env.VITE_TURNSTILE_SESSION_TTL_MS || 20 * 60 * 1000),
} as const
